module.exports = __webpack_public_path__ + "static/media/blank-ava.6732bd42.png";